import NSPDatePicker from '@components/ui/NSPDatepicker';
import { Form, Select, Row, Col, InputNumber } from 'antd';

const CoreInfoReplacementMeterInfoSection = ({ form, disabled = false }) => (
  <Row gutter={16}>
    <Col span={8}>
      <Form.Item label="Meter Swap" name="meterSwap">
        <Select
          options={[
            { value: 'Yes', label: 'Yes' },
            { value: 'No', label: 'No' },
          ]}
        />
      </Form.Item>
    </Col>
    <Col span={8}>
      <Form.Item label="Final Out Meter Read (KWH)" name="final_meter_read">
        <InputNumber style={{ width: '100%' }} />
      </Form.Item>
    </Col>
    <Col span={8}>
      <Form.Item label="Final Out Meter Read Date" name="final_read_date">
        <NSPDatePicker style={{ width: '100%' }} disabled={disabled} />
      </Form.Item>
    </Col>
  </Row>
);

export default CoreInfoReplacementMeterInfoSection;
